import * as React from 'react';

import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';
// import {Link} from 'shells/link/link';

import {MessageModalGraphic} from './assets/message-modal-graphic';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function MessageUnsubscribeModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<MessageModalGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>Unsubscribe rate</ModalHeader>
                    <SpacerGroup mb={32}>
                        <SpacerGroup mb={16}>
                            <ModalBody>
                                Clicking an <b>unsubscribe</b> link directs people to a landing page
                                where they can decide if they’d like to unsubscribe from all of your
                                messages or just ones sent to a specific audience.
                            </ModalBody>
                        </SpacerGroup>
                        <SpacerGroup mb={16}>
                            <ModalBody>
                                Nutshell keeps track of all unsubscribed people for you, so you
                                never have to worry about sending emails to those folks again.
                            </ModalBody>
                        </SpacerGroup>
                        {/* Uncomment & add correct link when article is published
                        <SpacerGroup mb={16}>
                            <ModalBody>
                                Learn more about{' '}
                                <Link href='https://support.nutshell.com'>
                                    how unsubscribes work
                                </Link>{' '}
                                in our knowledge base.
                            </ModalBody>
                        </SpacerGroup> */}
                    </SpacerGroup>
                </div>
            }
        />
    );
}
